import functions from "./functions"

const dictionary = {
    apiHost:functions.getHost(),
    _completeFields:"Complete all fields and try again"
}


export default dictionary